import React from 'react'
import { cx } from '../ui/format'

/** Kept for older screens: <Input name="Search" value={...} onChange={...} width="w-64" />. */
const Input = ({ name, value, onChange, width, type, className, ...other }) => {
  return (
    <input
      className={cx(
        'block h-10 px-3 rounded-cm border border-cm-border-strong bg-cm-surface-2 text-cm-text text-sm',
        'placeholder:text-cm-faint focus:outline-none focus:border-cm-gold focus:shadow-cm-focus',
        width || 'w-full sm:w-72',
        className,
      )}
      id={name}
      placeholder={name}
      aria-label={other['aria-label'] || name}
      value={value}
      onChange={onChange}
      type={type}
      {...other}
    />
  )
}

export default Input
